<template>
    <div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
        <div class="container">
            <div class="breadcrumb-nav">
                <div class="columns">
                    <div class="column is-9">
                        <nav class="breadcrumb has-arrow-separator" aria-label="breadcrumbs">
                            <ul>
                                <li><a href="/">{{ landing }}</a></li>
                                <li class="is-active"><a href="#">{{ offers_label }}</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="column is-3">
                        <div class="filter">
                            <form>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <label class="label">{{ order_label }} </label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control is-expanded has-icons-left">
                                            <div class="select is-fullwidth is-orange">
                                                <select v-model="orderBy" name="brand_filter">
                                                    <option selected value="created_at">{{ last_added}}</option>
                                                    <option value="views">{{ views }}</option>
                                                    <option value="rate">{{ best_rate }}</option>
                                                    <option value="price_desc">{{ high_price  }}</option>
                                                    <option value="price_asc">{{ low_price }}</option>
                                                </select>
                                            </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-3">
                    <div class="sidebar-search">
                        <nav class="panel">
                            <p class="panel-heading">
                                {{ filter_label }}
                            </p>
                            <div class="panel-container">
                                <span class="panel-head">
                                    {{ sub_categories_label }}
                                </span>
                                <div class="panel-inner">

                                    <div class="panel-block" v-for="(subCategory) in sub_categories">
                                        <div class="field">
                                            <input v-model="subCategoriesIds" :value="subCategory.id" :id="subCategory.name" class="is-checkradio is-info" :class="lang === 'en' ? 'false' : 'is-rtl'" type="checkbox">
                                            <label :for="subCategory.name">{{ subCategory.name }} </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel-container">
                                <span class="panel-head">
                                    {{ price_label }}
                                </span>
                                <div class="panel-inner">
                                    <div class="panel-block">
                                        <div class="field has-text-centered">
                                            <div class="columns">
                                                <div class="column is-6">
                                                    <label> {{ from_label}}
                                                        <input v-model="min_price" class="input m-t-10" type="number"  min="0" value="0">
                                                    </label>
                                                </div>
                                                <div class="column is-6">
                                                    <label> {{ to_label}}
                                                        <input v-model="max_price" class="input m-t-10" type="number"  min="0" value="0">
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="panel-container">
                                <span class="panel-head">
                                    {{ brands_label }}
                                </span>
                                <div class="panel-inner">

                                    <div class="panel-block" v-for="brand in brands">
                                        <div class="field">
                                            <input v-model="brandIds" :value="brand.id" :id="brand.name" class="is-checkradio is-info" :class="lang === 'en' ? 'false' : 'is-rtl'" type="checkbox">
                                            <label :for="brand.name">{{ brand.name }} </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </nav>
                    </div>
                </div>
                <div class="column is-9">
                    <div class="product-carousel">
                        <div class="columns is-multiline">
                            <div class="column is-4" v-for="offer in offers">
                                <div class="item hvr-grow">
                                    <a href="" class="link">
                                        <figure  class="image is-160x160">
                                            <img :src="offer.image">
                                        </figure>
                                        <span class="name">{{ offer.name }} </span>
                                    </a>
                                    <span class="price">{{ offer.price +' '+ currency }} </span>
                                   
                                    <div  v-if="offer.stock > 0" class="add-to-cart column-size">
                                        <div class="product-quantity cinpt"  :data-add-id="offer.id">
                                            <number-input :value="1" size="small" :min="offer.min" :max="offer.max" inline center controls></number-input>
                                        </div>
                                        <button type="submit" :data-offer-id="offer.offer_id" :data-product-id="offer.id" id="addToCart" class="button is-orange isSmall">{{ add }}</button>
                                    </div>
                                    <div class="offer">
                                        <span>{{ offer.discount_value }}%</span>
                                    </div>
                                    <div v-if="product.label != 'none'" class="product-labels">
                                        <span>{{ product.translated_label }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="has-text-centered m-t-30" v-show="loadMore">
                        <a href="#" class="loader-conatiner">
                            <div class="loader"></div>
                            <span>{{ more }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import infiniteScroll from 'vue-infinite-scroll';
    import NumberInput from '@chenfengyuan/vue-number-input';
    import StarRating from 'vue-star-rating'
    export default {
        name: "OfferFilter",
        components: {
            'number-input' : NumberInput,
            'star-rating' :StarRating
        },
        directives: {
            infiniteScroll
        },
        props: {
            lang:{
                type: String,
                required: true
            },
            url: String,
            landing : {
                type: String,
                required: true
            },
            currency: String,
            more:String,
            add : String,
            sub_categories: {
                type: Array,
                required: true
            },
            views:String,
            last_added:String,
            low_price:String,
            high_price:String,
            best_rate:String,
            order_label :String,
            rate_label : String,
            brands_label : String,
            price_label :String,
            from_label : String,
            to_label :String,
            filter_label :String,
            offers_label :String,
            sub_categories_label :String
        },
        computed: {
            busy() {
                return this.fetching
            }
        },
        data(){
            return {
                currentPage: 0,
                min_price:0,
                max_price:0,
                fetching: true,
                loadMore : true,
                nextUrl : String,
                orderBy: 'created_at',
                sortOrder: 'desc',
                offers: [],
                brands: [],
                brandIds: [],
                subCategoriesIds: [],
                rate : [],
                filter: 'created_at',
            };
        },
        created() {
            this.nextUrl = this.url;
            this.offers = [];
            this.loadNextPage();
        },
        mounted() {
            this.getBrands();
        },
        methods: {
            loadNextPage() {
                this.getOrderBy(this.orderBy);
                this.currentPage++;
                this.fetching = true;
                if(this.nextUrl != null){
                    axios.get(this.nextUrl,
                        {
                            params : {
                                'orderBy' : this.filter, 'direction' : this.sortOrder,
                                'min_price' : this.min_price, 'max_price' : this.max_price,
                                'brand_id' : this.brandIds, 'rate': this.rate
                            }
                        }
                    ).then(({ data }) => {
                        this.offers.push(...data.data);
                        if(data.links.next != null) {
                            this.nextUrl = data.links.next;
                        } else {
                            this.nextUrl = data.links.next;
                        }
                        this.fetching = false;
                    });
                }
                else{
                    this.loadMore = false;
                }
            },
            getBrands() {
                axios.get(`/api/brands`, {headers: { 'locale': this.lang }}).then(({ data }) => {
                    this.brands.push(...data.data);
                });
            },
            getOrderBy(val) {
                if(val == 'price_asc') {
                    this.sortOrder = 'asc';
                    this.filter = 'final_price';
                } else if(val == 'price_desc') {
                    this.sortOrder = 'desc';
                    this.filter = 'final_price';
                } else {
                    this.sortOrder = 'desc';
                    this.filter = val;
                }
            }
        },
        watch: {
            orderBy: function (val) {
                this.getOrderBy(val);
                this.offers = [];
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                )
                    .then(({data}) => {
                        this.offers = data.data;
                        if(data.links.next != null) {
                            this.loadMore = true;
                            this.nextUrl = data.links.next;
                        } else {
                            this.nextUrl = data.links.next;
                            this.loadMore = false;

                        }
                        this.currentPage = 0;
                        this.fetching = false;
                    });
            },
            min_price : function (val) {
                this.offers = [];
                this.getOrderBy(this.orderBy);
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                ).then(({data}) => {
                    this.offers = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            },
            max_price : function (val) {
                this.offers = [];
                this.getOrderBy(this.orderBy);
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                ).then(({data}) => {
                    this.offers = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            },
            brandIds : function (val) {
                this.offers = [];
                this.getOrderBy(this.orderBy);
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                ).then(({data}) => {
                    this.offers = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            },
            subCategoriesIds : function (val) {
                this.offers = [];
                this.getOrderBy(this.orderBy);
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                ).then(({data}) => {
                    this.offers = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            },
            rate : function (val) {
                this.offers = [];
                this.getOrderBy(this.orderBy);
                axios.get(`/${this.lang}/offers_filter`,
                    {
                        params : {
                            'orderBy' : this.filter, 'direction' : this.sortOrder,
                            'min_price' : this.min_price, 'max_price' : this.max_price,
                            'brand_id' : this.brandIds, 'rate': this.rate,
                            'sub_category_id' :this.subCategoriesIds
                        }
                    }
                ).then(({data}) => {
                    this.offers = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/OfferFilter.vue